import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL = 150;
export function ScarcityBar() {
  const [remaining, setRemaining] = useState(9);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 4 ? 9 : prev - 1);
    }, 42000);
    return () => window.clearInterval(id);
  }, []);
  const taken = TOTAL - remaining;
  const percent = Math.round(taken / TOTAL * 100);
  return <div className="rounded-2xl border border-gold/40 bg-[#FFF8E6] p-4" data-id="element-58" data-mp="2b8urvrn2ug0e">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-1" data-id="element-59" data-mp="2g6mhgf091q1f">
        <p className="flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-wide text-[#8A5B00]" data-id="element-60" data-mp="2273mknwg8b72">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="275on6ofm4ww1" />
          Cupos al precio promocional
        </p>
        <p className="text-[12px] font-bold text-[#8A5B00]" data-id="element-62" data-mp="fgq46tsfo37">{percent}% ocupado</p>
      </div>

      <div className="h-3.5 w-full overflow-hidden rounded-full bg-[#EBD9A8]" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos ocupados al precio promocional" data-id="element-63" data-mp="5d0ieanbm1e5">
        <div className="h-full rounded-full bg-bad transition-[width] duration-700 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-64" data-mp="3dcy1iohg6x66" />
      </div>

      <p className="mt-2.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-65" data-mp="2ko0ujhiosmsq">
        Solo quedan{' '}
        <span className="rounded-md bg-bad px-1.5 py-0.5 font-black text-white tabular-nums" data-id="element-66" data-mp="2gmoyou97z5c3">
          {remaining} cupos
        </span>{' '}
        para acceder por USD $15. Al agotarse, el precio vuelve a USD $97.
      </p>
    </div>;
}